// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__ZVvN8","active":"Sidebar_active__2-ivw","loginButton":"Sidebar_loginButton__3n5Lx"};